/* eslint-disable react/forbid-prop-types */
import React, { useState, createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { MdDelete } from 'react-icons/md';
import './AppConfirmation.scss';
import { Modal } from 'react-bootstrap';
import AppButton from '../app-button/AppButton';

export const AppConfirmationContext = createContext({
  showAppConfirmationDialog: () => {},
});

function AppConfirmationProvider({ children }) {
  const [state, setState] = useState({
    isOpen: false,
    successHandler: undefined,
    title: '',
    content: '',
    icon: undefined,
  });

  const appConfirmDialogContext = useMemo(
    () => ({
      showAppConfirmationDialog: (title, content, successHandler, icon) => {
        setState({
          isOpen: true,
          successHandler,
          title,
          content,
          icon,
        });
      },
    }),
    [],
  );

  const onModalClose = () => {
    setState({
      ...state,
      isOpen: false,
    });
  };

  return (
    <AppConfirmationContext.Provider value={appConfirmDialogContext}>
      <>
        <Modal
          backdrop="static"
          keyboard={false}
          className="app-confirmation-modal"
          show={state.isOpen}
          onHide={() => onModalClose()}
          size="md"
          // centered
        >
          <Modal.Body>
            <div className="app-confirmation-modal-body-container">
              {state.icon && (
                <div className="app-confirmation-icon-container">
                  {state.icon ? state.icon : <MdDelete />}
                </div>
              )}
              <div className="d-flex flex-column align-items-center">
                <span className="app-confirmation-title">{state.title}</span>
                <span className="app-confirmation-content">
                  {state.content}
                </span>
              </div>
              <div className="app-confirmation-button-container">
                <AppButton
                  variant="primary"
                  className="select-btn me-3"
                  onClick={() => {
                    if (state.successHandler) {
                      state.successHandler();
                    }
                    onModalClose(true);
                  }}
                  btnText="Yes"
                />
                <AppButton
                  variant="secondary"
                  className="select-btn"
                  onClick={() => onModalClose(false)}
                  btnText="No"
                />
              </div>
            </div>
          </Modal.Body>
        </Modal>
        {children}
      </>
    </AppConfirmationContext.Provider>
  );
}

AppConfirmationProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

export default AppConfirmationProvider;
